import ExamsDataStore from '../../datastores/ExamsDataStore';

const data3 = {
  exam: {
    scheduleV2: [
      {
        name: 'DERECHO PENAL ESPECIAL',
        desc: 'Examen Final',
        date: 1721779200000,
        startTime: 1721852100000,
        endTime: 1721857500000,
        start: 1721852100000,
        end: 1721857500000,
        address: 'SL08 - Lima Sur',
        room: 'AV030',
        building: 'UTP_71',
        classNbr: '45545',
        link: 'https://google.com',
        typeMod: 'R',
        buildingInformation: null,
        roomInformation: {
          building: 'AV',
          type: 'AULA VIRTUAL',
          floor: '0'
        }
      },
      {
        name: 'DERECHO PROCESAL ADMINISTRATIV',
        desc: 'Examen Final',
        date: 1721952000000,
        startTime: 1722024900000,
        endTime: 1722030300000,
        start: 1722024900000,
        end: 1722030300000,
        address: 'SL08 - Lima Sur',
        room: 'AV026',
        building: 'UTP_71',
        classNbr: '45546',
        link: null,
        typeMod: 'R',
        buildingInformation: null,
        roomInformation: {
          building: 'AV',
          type: 'AULA VIRTUAL',
          floor: '0'
        }
      },
      {
        name: 'DERECHO PROCESAL CIVIL I',
        desc: 'Exámenes Finales Presenciales',
        date: 1721865600000,
        startTime: 1721907000000,
        endTime: 1721912400000,
        start: 1721907000000,
        end: 1721912400000,
        address: 'SL08 - Lima Sur',
        room: 'A0812',
        building: 'UTP_71',
        classNbr: '25348',
        link: null,
        typeMod: 'P',
        buildingInformation: null,
        roomInformation: {
          building: 'A',
          type: 'AULA TEÓRICA',
          floor: '08'
        }
      },
      {
        name: 'CURSO INTEGRADOR I: INTERDISCI',
        desc: 'Exámenes Finales Presenciales',
        date: 1721865600000,
        startTime: 1721913300000,
        endTime: 1721918700000,
        start: 1721913300000,
        end: 1721918700000,
        address: 'SL08 - Lima Sur',
        room: 'B0805',
        building: 'UTP_71',
        classNbr: '25353',
        link: null,
        typeMod: 'P',
        buildingInformation: null,
        roomInformation: {
          building: 'B',
          type: 'AULA TEÓRICA',
          floor: '08'
        }
      },
      {
        name: 'CONTRATOS',
        desc: 'Exámenes Finales Presenciales',
        date: 1721865600000,
        startTime: 1721932200000,
        endTime: 1721937600000,
        start: 1721932200000,
        end: 1721937600000,
        address: 'SL08 - Lima Sur',
        room: 'B0305',
        building: 'UTP_71',
        classNbr: '36791',
        link: null,
        typeMod: 'P',
        buildingInformation: null,
        roomInformation: {
          building: 'B',
          type: 'AULA TEÓRICA',
          floor: '03'
        }
      }
    ]
  }
};

export default class ExamsDataStoreMock implements ExamsDataStore {
  async getExams() {
    return data3.exam.scheduleV2;
  }
}
